define('core/utils/object/get',[],function () {
    'use strict';


    /**
     * Safely accesses a deeply-nested property of objects.
     *
     * @param {Object} obj The object to start with
     * @param {Array<string>} path An array of keys to the nested property
     * @param {*} [defaultValue] The value to return if the deeply nested
     *                           property is undefined or does not exist
     * @returns {*} The accessed property, or defaultValue.
     */
    return function get(obj, path, defaultValue) {
        var i = 0;
        var len = path.length;

        while (obj && i < len) {
            obj = obj[path[i]];
            i += 1;
        }

        if (i < len || obj === undefined)
            return defaultValue;

        return obj;
    };
});

